// Quality control component with compression slider
import React from 'react';
import {
  Box,
  Flex,
  Text,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from '@chakra-ui/react';

interface QualityControlProps {
  quality: number;
  onQualityChange: (value: number) => void;
}

export const QualityControl: React.FC<QualityControlProps> = ({ quality, onQualityChange }) => {
  return (
    <Box
      bg="background.secondary"
      borderRadius="xl"
      p={5}
      border="1px solid"
      borderColor="border.default"
    >
      <Flex justify="space-between" align="center" mb={3}>
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color="text.secondary"
          textTransform="uppercase"
          letterSpacing="wider"
          fontFamily="secondary"
        >
          Quality
        </Text>
        <Text
          fontSize="sm"
          color="brand.primary.DEFAULT"
          fontWeight="semibold"
          fontFamily="secondary"
        >
          {quality}%
        </Text>
      </Flex>

      <Text fontSize="xs" color="text.secondary" mb={2} fontFamily="secondary">
        Compression
      </Text>
      <Slider value={quality} onChange={onQualityChange} min={1} max={99} step={1}>
        <SliderTrack bg="background.tertiary" h={2} borderRadius="full">
          <SliderFilledTrack bg="brand.primary.DEFAULT" />
        </SliderTrack>
        <SliderThumb
          boxSize={4}
          bg="brand.primary.DEFAULT"
          _focus={{ boxShadow: '0 0 0 3px rgba(167, 28, 41, 0.3)' }}
        />
      </Slider>
      <Flex justify="space-between" mt={2}>
        <Text fontSize="xs" color="text.secondary" fontFamily="secondary">
          Smaller file
        </Text>
        <Text fontSize="xs" color="text.secondary" fontFamily="secondary">
          Higher quality
        </Text>
      </Flex>
    </Box>
  );
};
